"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../../../shared/utils/cn.js";
export function PriceSkeleton({ className }) {
    return (_jsx("span", { className: cn("animate-pulse-fade bg-b3-react-background inline-block h-4 w-16 rounded-md align-middle", className), "aria-hidden": "true" }));
}
